import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "@/components/boost/Navbar";
import Footer from "@/components/boost/Footer";
import StickyMobileCTA from "@/components/boost/StickyMobileCTA";
import Hero from "@/sections/Hero";
import WhyBoostF from "@/sections/WhyBoostF";
import MeetMentor from "@/sections/MeetMentor";
import RealResults from "@/sections/RealResults";
import Roadmap from "@/sections/Roadmap";
import WhatYouWillLearn from "@/sections/WhatYouWillLearn";
import Bonuses from "@/sections/Bonuses";
import WhoShouldJoin from "@/sections/WhoShouldJoin";
import MarathonSchedule from "@/sections/MarathonSchedule";
import WhyOnly99 from "@/sections/WhyOnly99";
import Reserve from "@/sections/Reserve";
import FAQ from "@/sections/FAQ";
import FinalCTA from "@/sections/FinalCTA";

const Home = () => (
  <div className="relative">
    <Helmet>
      <title>BoostF — eCommerce Launch Marathon | ₹99 Only</title>
      <meta name="description" content="Build. Launch. Scale. Your eCommerce Business. Join the BoostF eCommerce Launch Marathon for just ₹99." />
    </Helmet>
    <Navbar />
    <main>
      <Hero />
      <WhyBoostF />
      <MeetMentor />
      <RealResults />
      <Roadmap />
      <WhatYouWillLearn />
      <Bonuses />
      <WhoShouldJoin />
      <MarathonSchedule />
      <WhyOnly99 />
      <Reserve />
      <FAQ />
      <FinalCTA />
    </main>
    <Footer />
    <StickyMobileCTA />
  </div>
);

export default Home;
